// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608170455/js/" + chunkId + "." + {"44":"57766f4a","225":"ed12d527","481":"943b0e63","486":"273ec529","770":"8d7cd094"}[chunkId] + ".0.009356564664574019.chunk.js";
};